import { usePropertyRemindersListQuery } from "web_myplann/Api/Reminders/usePropertyRemindersListQuery";
import { RemindersSectionView } from "web_myplann/Reminders/Components/RemindersSectionView";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
};

export const PropertyRemindersSectionContent = ({ entity }: Props) => {
	const { data, isLoading, isError } = usePropertyRemindersListQuery(entity.id);

	return (
		<RemindersSectionView
			entity={entity}
			reminders={data}
			isLoading={isLoading}
			isError={isError}
		/>
	);
};
